import { render, staticRenderFns } from "./addPredeterStudent.vue?vue&type=template&id=3bb7e181&scoped=true&"
import script from "./addPredeterStudent.vue?vue&type=script&lang=js&"
export * from "./addPredeterStudent.vue?vue&type=script&lang=js&"
import style0 from "./addPredeterStudent.vue?vue&type=style&index=0&id=3bb7e181&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bb7e181",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\admin\\drone_race_manage\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3bb7e181')) {
      api.createRecord('3bb7e181', component.options)
    } else {
      api.reload('3bb7e181', component.options)
    }
    module.hot.accept("./addPredeterStudent.vue?vue&type=template&id=3bb7e181&scoped=true&", function () {
      api.rerender('3bb7e181', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/divisionManage/divisionAllController/component/addPredeterStudent.vue"
export default component.exports